import React from 'react'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import SchedulingSectorOrdersLayout from 'presentation/hospital/layouts/Home/SchedulingSector/Orders'
import { SchedulingStatus } from 'presentation/hospital/components/Tables/SchedulingSectorOrdersDataGrid/styles'
import { CreateSurgicalSchedulingProvider } from 'presentation/hospital/layouts/Home/SchedulingSector/context-create-surgical-scheduling'

const SchedulingSectorAllOrders = () => (
  <CreateSurgicalSchedulingProvider>
    <ContainerNew>
      <SchedulingSectorOrdersLayout status={SchedulingStatus.ALL} />
    </ContainerNew>
  </CreateSurgicalSchedulingProvider>
)

export default SchedulingSectorAllOrders
